// Per-pro "already contacted" memory — lets a contact button switch to a
// persistent "✅ opened" state and re-fire the same action on a repeat click,
// with no popup gate.

const KEY = 'ex_contacted';

export type ContactedIntent = 'whatsapp' | 'call';
export type ContactedEntry = { intent: ContactedIntent; at: number };

// Keyed by proId when available; WAButton has no proId prop, so it falls back
// to the phone number so the "sent" state still works there.
function storeKey(proId?: number, phone?: string | null): string | null {
  if (proId) return `pro:${proId}`;
  const digits = (phone || '').replace(/\D/g, '');
  return digits ? `phone:${digits}` : null;
}

export function getContacted(proId?: number, phone?: string | null): ContactedEntry | null {
  const k = storeKey(proId, phone);
  if (!k) return null;
  try {
    const all = JSON.parse(localStorage.getItem(KEY) || '{}');
    return all[k] || null;
  } catch {
    return null;
  }
}

export function setContacted(proId: number | undefined, phone: string | null | undefined, intent: ContactedIntent) {
  const k = storeKey(proId, phone);
  if (!k) return;
  try {
    const all = JSON.parse(localStorage.getItem(KEY) || '{}');
    all[k] = { intent, at: Date.now() } as ContactedEntry;
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent('experts:contacted', { detail: { proId, intent } }));
  } catch {}
}
